import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useAnimalFilters } from '../../hooks/animalFilters';
import api from '../../services/api';

import { IconX } from '@tabler/icons';
import Button from '../Button';
import Modal from '../Modal';
import { DeleteButton, H2 } from '../Generic';
import { FiltersGrid } from './styles';
import LoadingComponent from './components/LoadingComponent';
import CustomSelectInput from './components/CustomSelectInput';

interface ModalProps {
  propertyId: string;
  onClose: () => void;
  isOpen: boolean;
  [x: string]: any;
}

export default function FiltersModal({
  propertyId,
  isOpen,
  onClose,
}: ModalProps) {
  const [loading, setLoading] = useState(true);
  const [validFilters, setValidFilters] = useState<any>({});

  const history = useHistory();
  const { animalFilters, setAnimalFilters } = useAnimalFilters();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      const filtersResponse = await api.get(`/animais/filtros/validos`, {
        headers: {
          propriedade_id: propertyId,
        },
      });

      const safras = filtersResponse.data.safras.sort((a: any, b: any) => {
        return a - b;
      });

      setValidFilters({
        ...filtersResponse.data,
        safras,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const genderOptions = [
    { value: '', label: 'Qualquer' },
    { value: 'macho', label: 'Macho' },
    { value: 'femea', label: 'Fêmea' },
  ];

  const stateOptions = [
    { value: 'ativo', label: 'Ativo' },
    { value: 'inativo', label: 'Inativo' },
  ];

  const relationOptions = [
    { value: 'true', label: 'Pertencentes' },
    { value: '', label: 'Externos' },
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <H2>Filtros</H2>

      {loading ? (
        <LoadingComponent />
      ) : (
        <>
          <FiltersGrid>
            <CustomSelectInput
              label="Estado"
              onChange={(e: any) =>
                setAnimalFilters({ ...animalFilters, estado: e.target.value })
              }
              value={animalFilters.estado}
              filters={stateOptions}
            />

            <CustomSelectInput
              label="Relação"
              onChange={(e: any) =>
                setAnimalFilters({
                  ...animalFilters,
                  pertencentes: e.target.value,
                })
              }
              value={animalFilters.pertencentes}
              filters={relationOptions}
            />

            <CustomSelectInput
              label="Sexo"
              onChange={(e: any) =>
                setAnimalFilters({
                  ...animalFilters,
                  sexo: e.target.value,
                })
              }
              value={animalFilters.sexo}
              filters={genderOptions}
            />

            <CustomSelectInput
              label="Raça"
              onChange={(e: any) =>
                setAnimalFilters({
                  ...animalFilters,
                  raça: e.target.value,
                })
              }
              value={animalFilters.raça}
              filters={validFilters.racas}
            />

            <CustomSelectInput
              label="Ano de nascimento"
              onChange={(e: any) =>
                setAnimalFilters({
                  ...animalFilters,
                  ano: e.target.value,
                })
              }
              value={animalFilters.ano}
              filters={validFilters.datas_de_nascimento}
            />

            <CustomSelectInput
              label="Safra"
              onChange={(e: any) =>
                setAnimalFilters({
                  ...animalFilters,
                  safra: e.target.value,
                })
              }
              value={animalFilters.safra}
              filters={validFilters.safras}
            />

            <CustomSelectInput
              label="Categoria"
              onChange={(e: any) =>
                setAnimalFilters({
                  ...animalFilters,
                  categoria: e.target.value,
                })
              }
              value={animalFilters.categoria}
              filters={validFilters.categorias}
            />

            <CustomSelectInput
              label="Lote"
              onChange={(e: any) =>
                setAnimalFilters({
                  ...animalFilters,
                  lote: e.target.value,
                })
              }
              value={animalFilters.lote}
              filters={validFilters.lotes}
            />
          </FiltersGrid>

          <Button onClick={onClose} style={{ marginTop: 32 }}>
            Aplicar
          </Button>

          <DeleteButton
            type="button"
            onClick={() => {
              setAnimalFilters({
                estado: 'ativo',
                sexo: '',
                ano: '',
                raça: '',
                categoria: '',
                safra: '',
                lote: '',
                pertencentes: 'true',
              });

              onClose();
            }}
          >
            <IconX size={24} style={{ marginRight: 10 }} />
            Limpar filtros
          </DeleteButton>
        </>
      )}
    </Modal>
  );
}
